<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="provaScrittaForm">
<form #f="ngForm" [formGroup]="provaScrittaForm" (ngSubmit)="update();">
	<div class="row">
		<div comboModInput [control]="provaScrittaForm.controls['tipoProvaScritta']"
			[mandatory]="true" class="col-sm-6" [labelInput]="'Tipo prova scritta'"
			formControlName="tipoProvaScritta" [objectReference]="request.tipoProvaScritta"
			[ngModel]="request.tipoProvaScritta"
			(onReturn)="request.tipoProvaScritta = $event"
			[optionsCombo] ="tipoProvaScrittaOptions"></div>
		<div
			textInputCurrency [control]="provaScrittaForm.controls['valore']"
			class="col-sm-6" [labelInput]="'Valore'"
			formControlName="valore" [location]="'SezioneEconomica'" 
			[(ngModel)]="request.valore"></div>
	</div>
	<div class="row">
		<div datePickerInput class="col-sm-6"
			[control]="provaScrittaForm.controls['scadenza']"
			[labelInput]="'Data scadenza'"
			formControlName="scadenza" [(ngModel)]="request.scadenza"></div>
		<div textInput [control]="provaScrittaForm.controls['descrizione']"
			class="col-sm-6" [labelInput]="'Descrizione'"
			formControlName="descrizione" [(ngModel)]="request.descrizione"></div>
	</div>
	<div class="row">
		<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
			formControlName="note" [(ngModel)]="request.note"></div>
	</div>
<!-- 	<div class="row"> -->
<!-- 		<div textInput [control]="provaScrittaForm.controls['note']" -->
<!-- 			class="col-sm-12" [labelInput]="'Note'" formControlName="note" -->
<!-- 			[(ngModel)]="request.note"></div> -->
<!-- 	</div> -->
	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
		</p>
		<p submitButton
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[labelButton]="'Salva'" [disabled]="!provaScrittaForm.valid">
	</div>
</form>
</ng-template>
